/* Infinite scroll / Load more — opt-in PLP pagination alternative.
   Driven by the [data-plp-loadmore] block in main-collection.liquid.
   data-mode = "infinite_scroll" auto-fetches the next page when the
   sentinel scrolls into view; data-mode = "load_more" waits for a
   click on the button. Either way: fetch the next URL, extract the
   .plp-grid__items > children, append to the existing grid, advance
   the data-next-url to the new page's "next" link. */
(function () {
  const init = (node) => {
    if (node.dataset.lmInit) return;
    node.dataset.lmInit = '1';

    const mode = node.getAttribute('data-mode');
    const button = node.querySelector('[data-plp-loadmore-btn]');
    const endEl  = node.querySelector('.plp-loadmore__end');
    const grid   = document.querySelector('[data-plp-grid]');
    if (!grid) return;

    let loading = false;
    let nextUrl = node.getAttribute('data-next-url') || '';

    const showEnd = () => {
      if (button) button.setAttribute('hidden', '');
      if (endEl) {
        endEl.textContent = node.getAttribute('data-end-message') || '';
        endEl.removeAttribute('hidden');
      }
    };

    const fetchNext = async () => {
      if (loading || !nextUrl) return;
      loading = true;
      if (button) {
        button.setAttribute('disabled', '');
        button.dataset.originalLabel = button.dataset.originalLabel || button.textContent;
        button.textContent = 'Loading…';
      }
      try {
        const res = await fetch(nextUrl, { credentials: 'same-origin' });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const html = await res.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');

        // Append new product cards to the existing grid.
        const newGrid = parsed.querySelector('[data-plp-grid]');
        if (newGrid) {
          Array.from(newGrid.children).forEach((child) => {
            grid.appendChild(child);
          });
        }

        // Advance the next-URL pointer using the freshly loaded page's
        // own loadmore block (which carries the correct "next" link).
        const freshLoadMore = parsed.querySelector('[data-plp-loadmore]');
        if (freshLoadMore) {
          const newNext = freshLoadMore.getAttribute('data-next-url') || '';
          nextUrl = newNext;
          node.setAttribute('data-next-url', newNext);
          if (!newNext) showEnd();
        } else {
          // No loadmore block in the new page → we're at the end.
          nextUrl = '';
          showEnd();
        }
      } catch (err) {
        if (button) {
          button.removeAttribute('disabled');
          button.textContent = button.dataset.originalLabel || 'Load more';
        }
      } finally {
        loading = false;
        if (button && nextUrl) {
          button.removeAttribute('disabled');
          button.textContent = button.dataset.originalLabel || button.textContent;
        }
      }
    };

    if (button && mode === 'load_more') {
      button.addEventListener('click', fetchNext);
    }

    if (mode === 'infinite_scroll' && 'IntersectionObserver' in window) {
      // Hide the button (visual cue isn't needed for true infinite scroll)
      if (button) button.style.display = 'none';
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => { if (entry.isIntersecting) fetchNext(); });
      }, { rootMargin: '600px 0px' });
      io.observe(node);
    }
  };

  const boot = () => document.querySelectorAll('[data-plp-loadmore]').forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
